import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { postDashboardForm } from '../api/apiClient'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';
import { ROCELL_COLORS, OTA_OTD_CHART_COLORS } from '../theme/rocellTheme';

export class PieChart extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "pie"
                },
                labels: ['Delivered', 'Undelivered'],
                legend: { position: 'bottom' },
                colors: OTA_OTD_CHART_COLORS,
            },
            series: [],
            allSeries: [],
            isLoaded: false,
            filterDateTo: '',
            filterDateFrom: '',
            exportRecords: [],
            totalRecords: [],
            totalOrders: 0,
            delivered: 0,
            undelivered: 0,
            allDelivered: 0,
            allUndelivered: 0,
            allAllEntries: [],
            allSeries: [],
            oracleDuplicateCount: 0,
        };

        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(data) {
        this.setState((prevState) => ({
            series: data
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            this.setState({ filterDateFrom: event.target.value })
        }
    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const dataUrl = API_URL + "/Bi_dashboard_otd"

        postDashboardForm(dataUrl, formData).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data;
                const dataArray = [reportData.delivered, reportData.undelivered];
                const allDataArray = [
                    reportData.count_all_delivered || 0,
                    reportData.count_all_undelivered || 0,
                ];
                const chartDataLabels = {
                    enabled: true,
                    formatter: function(val, opts) {
                        return val.toFixed(1) + '% (' + opts.w.globals.series[opts.seriesIndex] + ')';
                    },
                    style: {
                        fontSize: '14px',
                        colors: ['#fff']
                    }
                };
                this.setState({
                    exportRecords: reportData.oracle_duplicate_orders,
                    totalRecords: reportData.total_records || [],
                    totalOrders: reportData.total_orders,
                    delivered: reportData.delivered,
                    undelivered: reportData.undelivered,
                    allDelivered: reportData.count_all_delivered || 0,
                    allUndelivered: reportData.count_all_undelivered || 0,
                    allAllEntries: reportData.all_all_entries || [],
                    oracleDuplicateCount: reportData.oracle_duplicate_orders_count,
                    series: dataArray,
                    allSeries: allDataArray,
                    options: {
                        chart: { type: "pie" },
                        labels: ['Delivered', 'Undelivered'],
                        legend: { position: 'bottom' },
                        colors: OTA_OTD_CHART_COLORS,
                        dataLabels: chartDataLabels,
                    },
                    allOptions: {
                        chart: { type: "pie" },
                        labels: ['Delivered', 'Undelivered'],
                        legend: { position: 'bottom' },
                        colors: OTA_OTD_CHART_COLORS,
                        dataLabels: chartDataLabels,
                    },
                    isLoaded: true
                });
            } else {
                console.log("No data returned from API")
                this.setState({ isLoaded: true })
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const newFromDate = this.state.filterDateFrom;

        const formData = new FormData();
        formData.append('filter_date_from', newFromDate);
        // formData.append('filter_date_to', newToDate);
    // mark loading and clear current table records so old data doesn't show while fetching
    this.setState({ isLoaded: false, tableRecords: [] })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();
        var currentDate = new Date();
        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_from', formattedDateFrom);
        // formData.append('filter_date_to', formattedDateTo);
        this.setState({ filterDateFrom: formattedDateFrom })
        this.setState({ filterDateTo: formattedDateTo })
        this.getData(formData);
    }

    render() {
        const oracleExportHeaders = [
          { label: "Line ID", key: "LINE_ID" },
          { label: "Invoice Number", key: "INVOICE_NUMBER" },
          { label: "SKU Code", key: "SKU_CODE" },
          { label: "Source Warehouse", key: "SOURCE_WAREHOUSE" },
          { label: "Document Owner", key: "DOCUMENT_OWNER" },
        ];

        const totalRecordsExportData = this.state.totalRecords.map(r => ({
          "Invoice Number":    r.invoice_number,
          "Requested Shipment Date": r.req_shipment_date,
          "Shipment Date" : r.shipment_date,
          "Location Code":    r.location_code,
          "SKU Code":         r.sku_code,
          "SKU Description":  r.sku_description,
          "Transaction Source": r.transaction_source,
          "ISO Order Type":   r.iso_order_type,
          "Shipment Status":  r.tms_shp_status,
        }));

        const approvedShipments = this.state.totalRecords.filter(r => r.tms_shp_status === 'Approved').length;
        const holdShipments = this.state.totalRecords.filter(r => r.tms_shp_status === 'Pending').length;
        const attendedShipments = this.state.totalRecords.filter(r => r.tms_shp_status === 'Attended').length;

        const allApprovedShipments = this.state.allAllEntries.filter(r => r.tms_shp_status === 'Approved').length;
        const allHoldShipments = this.state.allAllEntries.filter(r => r.tms_shp_status === 'Pending').length;
        const allAttendedShipments = this.state.allAllEntries.filter(r => r.tms_shp_status === 'Attended').length;
        const allTotalOrders = this.state.allAllEntries.length;

        console.log("totalRecords state length:", this.state.totalRecords.length);
        console.log(totalRecordsExportData)

        const currentDate = new Date().toISOString().split('T')[0];
        const exportDate = this.state.filterDateFrom || currentDate;
        const oracleOrdersFileName = `Overlapped Orders ${exportDate}`;
        const totalRecordsFileName = `Total Records ${exportDate}`;
        const exportButtonStyle = {
            height: '32px',
            minWidth: 'auto',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px 10px',
            fontSize: '12px',
            flexShrink: 0,
        };
        const chartContainerStyle = { height: '280px', overflow: 'hidden' };
        const tableContainerStyle = { height: '230px', overflow: 'auto' };

        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0 pt-5'>
                    <div className='row align-items-center'>
                        <div className='col-lg-4'>
                            <p className='card-title align-items-start flex-column mb-0'>
                                <span className='card-label fw-bold mb-1'>
                                    On Time Delivery
                                    <br /> <span className='bi-date-muted'>{this.state.filterDateFrom}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-lg-8 bi-chart-actions mt-3 mt-lg-0'>
                            <div className='d-flex align-items-center me-4'>
                                <button
                                    type='button'
                                    className='btn btn-sm btn-light-primary'
                                    data-kt-menu-trigger='click'
                                    data-kt-menu-placement='bottom-end'
                                    data-kt-menu-flip='top-end'>
                                    <i className='fas fa-filter me-1'></i> Filter
                                </button>

                                <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    {/* <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div> */}

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <ExcelExport
                              data={this.state.exportRecords}
                              headers={oracleExportHeaders}
                              fileName={oracleOrdersFileName}
                              title="Overlapped"
                              variant="light"
                              buttonStyle={exportButtonStyle}
                            />
                            <ExcelExport
                              data={totalRecordsExportData}
                              fileName={totalRecordsFileName}
                              title="Total"
                              variant="dark"
                              buttonStyle={exportButtonStyle}
                            />
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row align-items-start mb-6'>
                        <div className='col-12 col-lg-7'>
                            {!this.state.isLoaded ? (
                                <div style={{ ...chartContainerStyle, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Circles
                                        height="80"
                                        width="80"
                                        color={ROCELL_COLORS.primary}
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                </div>
                            ) : (
                                <div style={chartContainerStyle}>
                                    <Chart
                                        key="on-time-delivery-chart"
                                        options={{
                                            ...this.state.options,
                                            chart: { ...this.state.options.chart, id: 'on-time-delivery-chart' },
                                        }}
                                        series={this.state.series}
                                        type="pie"
                                        width="100%"
                                        height="100%"
                                    />
                                </div>
                            )}
                        </div>

                        <div className='col-12 col-lg-5' style={tableContainerStyle}>
                            {!this.state.isLoaded ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                    <Circles height="80" width="80" color={ROCELL_COLORS.primary} ariaLabel="table-loading" visible={true} />
                                </div>
                            ) : (
                                <table className='table table-bordered bi-data-table'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>METRIC</th>
                                            <th className='text-center'>COUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='text-center'>Total Orders</td>
                                            <td className='text-center'>{this.state.totalOrders}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>Delivered</td>
                                            <td className='text-center'>{this.state.delivered}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>Undelivered</td>
                                            <td className='text-center'>{this.state.undelivered}</td>
                                        </tr>
                                        <tr className='bi-sub-row'>
                                            <td className='text-center'>↳ Pending</td>
                                            <td className='text-center'>{holdShipments}</td>
                                        </tr>
                                        <tr className='bi-sub-row'>
                                            <td className='text-center'>↳ Approved</td>
                                            <td className='text-center'>{approvedShipments}</td>
                                        </tr>
                                        <tr className='bi-sub-row'>
                                            <td className='text-center'>↳ Attended</td>
                                            <td className='text-center'>{attendedShipments}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>Overlapped Orders</td>
                                            <td className='text-center'>{this.state.oracleDuplicateCount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>

                    <div className='row align-items-start bi-section-divider'>
                        <div className='col-12 mb-4'>
                            <span className='bi-section-title'>Overall OTD</span>
                        </div>
                        <div className='col-12 col-lg-7'>
                            {!this.state.isLoaded ? (
                                <div style={{ ...chartContainerStyle, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Circles
                                        height="80"
                                        width="80"
                                        color={ROCELL_COLORS.primary}
                                        ariaLabel="overall-otd-loading"
                                        visible={true}
                                    />
                                </div>
                            ) : (
                                <div style={chartContainerStyle}>
                                    <Chart
                                        key="overall-otd-chart"
                                        options={{
                                            ...(this.state.allOptions || this.state.options),
                                            chart: { ...(this.state.allOptions || this.state.options).chart, id: 'overall-otd-chart' },
                                        }}
                                        series={this.state.allSeries}
                                        type="pie"
                                        width="100%"
                                        height="100%"
                                    />
                                </div>
                            )}
                        </div>

                        <div className='col-12 col-lg-5' style={tableContainerStyle}>
                            {!this.state.isLoaded ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                    <Circles height="80" width="80" color={ROCELL_COLORS.primary} ariaLabel="overall-otd-table-loading" visible={true} />
                                </div>
                            ) : (
                                <table className='table table-bordered bi-data-table'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>METRIC</th>
                                            <th className='text-center'>COUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='text-center'>Total Orders</td>
                                            <td className='text-center'>{allTotalOrders}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>Delivered</td>
                                            <td className='text-center'>{this.state.allDelivered}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>Undelivered</td>
                                            <td className='text-center'>{this.state.allUndelivered}</td>
                                        </tr>
                                        <tr className='bi-sub-row'>
                                            <td className='text-center'>↳ Pending</td>
                                            <td className='text-center'>{allHoldShipments}</td>
                                        </tr>
                                        <tr className='bi-sub-row'>
                                            <td className='text-center'>↳ Approved</td>
                                            <td className='text-center'>{allApprovedShipments}</td>
                                        </tr>
                                        <tr className='bi-sub-row'>
                                            <td className='text-center'>↳ Attended</td>
                                            <td className='text-center'>{allAttendedShipments}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}